import { ProductsWithEligibility } from 'src/api/@generated/backend';

import { api } from 'src/api';
import { selectSelectedAccountOrThrow } from 'src/state/account/selectors';
import { selectSelectedServiceLocationOrThrow } from 'src/state/address/selectors';
import { createAppAsyncThunk } from 'src/state/thunk-api';
import { handleError } from 'src/utils/error-utils';

export const fetchProductsWithEligibilityActionCreator = createAppAsyncThunk<ProductsWithEligibility>(
  'request/fetchProductsActionCreator',
  async (_, { getState }) => {
    const rootState = getState();
    const account = selectSelectedAccountOrThrow(rootState);
    const serviceLocation = selectSelectedServiceLocationOrThrow(rootState);
    const { partnerId, customerId } = account;
    const { integrationId } = serviceLocation;

    try {
      return await api.shopController.getSellableProducts({
        partnerId,
        billingAccountId: customerId,
        servicePointId: integrationId,
      });
    } catch (error: any) {
      handleError(error);
      return Promise.reject();
    }
  },
);
